/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Modal } from 'react-bootstrap';
import { toAbsoluteUrl } from '../../../../../../_metronic_front/helpers';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToastMessageSuccess, showToastMessageError } from '../../../../../modules/Toast-Message/TosatMessage';
import axios from 'axios';

const modalsRoot = document.getElementById('root-modals') || document.body;

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v';

const getLocalData = () => {
    const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
    return JSON.parse(data);
}

const AddBank = ({ show, handleClose, EditBankData, SuccessRefresh }) => {

    const apiToken = getLocalData().api_token;

    const [editable,setEditable] =useState(false);

    const [itemId,setItemId] = useState();
    const [accountName,setAccountName] = useState();
    const [accountType,setAccountType] = useState("1");
    const [bankName,setBankName] = useState();
    const [accountNumber,setAccountNumber] = useState();
    const [routingNumber,setRoutingNumber] = useState();
    const [primaryStatus,setPrimaryStatus] = useState(0);

    const [showOTPInput,setShowOTPInput] = useState(false);
    const [OTPVerified,setOTPVerified] = useState(false);
    const [currentOTP,setCurrentOTP] = useState("");
    const [otp,setOTP] = useState("");
    const [otpErr,setOTPErr] = useState();
    const [btnLoading, setBtnLoading] = useState(false);

    const [bankErr, setBankErr] = useState([
        {
            card_provdierErr : '',
            accountNameErr : '',
            accountTypeErr:'',
            bankNameErr : '',
            accountNumberErr : '',
            routingNumberErr : '',
            primary_statusErr : ''
        }
    ]);


    const API_URL = process.env.REACT_APP_API_URL;
   
    
    const BANK_ADD = `${API_URL}/user/bank/add`;
    const BANK_UPDATE = `${API_URL}/user/bank/update`;
     const SEND_VERIFY_OTP = `${API_URL}/banking-Detail/send-otp`;

 
    const CheckEdit = ()=>{    
        // console.log(Edit);
        
        if(EditBankData != ''){
            setItemId(EditBankData.item_id);
            setAccountName(EditBankData.account_name);
            setAccountType(EditBankData.account_type);
            setBankName(EditBankData.bank_name);
            setAccountNumber(EditBankData.account_number);
            setRoutingNumber(EditBankData.routing_number);
            setPrimaryStatus(EditBankData.primary_status);
            setEditable(true)
        }
    }

    useEffect(()=>{
        CheckEdit();
    },[EditBankData])


    const handleChangeAccountName = (e) =>{
        const { value } = e.target;
        setAccountName(value)
    }
    const handleChangeAccountType = (e) =>{
        const { value } = e.target;
        setAccountType(value)
    }
    const handleChangeBankName = (e) =>{
        const { value } = e.target;
        setBankName(value)
    }
    const handleChangeAccountNumber = (e) =>{
        const { value } = e.target;
        setAccountNumber(value)
    }
    const handleChangeRoutingNumber = (e) =>{
        const { value } = e.target;
        setRoutingNumber(value)
    }
    const handleChangePrimaryStatus = (e,value) =>{
        const { checked } = e.target;
        if(checked == true){
        setPrimaryStatus(1)
        }
        else{
            setPrimaryStatus(0)
        }
    }

    const ClearBankStates = () =>{
        setAccountName("");
        setAccountType("1");
        setBankName("");
        setAccountNumber("");
        setRoutingNumber("");
        setPrimaryStatus(0);

        setOTP("");
        setCurrentOTP("");
        setOTPErr("")
        setShowOTPInput(false);
        setOTPVerified(false)
    }

    const submitForm = ()=>{
        if(editable == true){
            UpdateBankRequest()
        }else{
            AddBankRequest()
        }
    }

    const AddBankRequest = () =>{
        axios.post(BANK_ADD, {
            account_name: accountName,
            account_type: accountType,
            bank_name: bankName,
            account_number: accountNumber,
            routing_number: routingNumber,
            primary_status: primaryStatus,
        }).then((response) => {
            showToastMessageSuccess(response.data.message);
            ClearBankStates();
            SuccessRefresh();
            setBtnLoading(false)
            handleClose();
        })
        .catch((error) => {
            console.error(error);
            showToastMessageError(error.message);
            setBtnLoading(false)
        });
    }

    const UpdateBankRequest = () =>{
        axios.post(BANK_UPDATE, {
            bank_id:itemId,
            account_name: accountName,
            account_type: accountType,
            bank_name: bankName,
            account_number: accountNumber,
            routing_number: routingNumber,
            primary_status: primaryStatus,
        }).then((response) => {
            showToastMessageSuccess(response.data.message);
            ClearBankStates();
            SuccessRefresh();
            handleClose();
            setBtnLoading(false)
        })
        .catch((error) => {
            console.error(error);
            showToastMessageError(error.message);
            setBtnLoading(false)
        });
    }

    const saveUserBank = async () => {
        setBankErr((prev) => ({
            ...prev,
            accountNameErr: '',
            bankNameErr: '',
            accountTypeErr: '',
            accountNumberErr: '',
            routingNumberErr: ''
        }));
        if (!accountName || accountName === "") {
            setBankErr((prev) => ({
                ...prev,
                accountNameErr: 'enter account name'
            }));
        } else if (!bankName || bankName === "") {
            setBankErr((prev) => ({
                ...prev,
                bankNameErr: 'enter bank name'
            }));
        } else if (!accountType || accountType == 0) {
            setBankErr((prev) => ({
                ...prev,
                accountTypeErr: 'select account type'
            }));
        } else if (!accountNumber || accountNumber === "") {
            setBankErr((prev) => ({
                ...prev,
                accountNumberErr: 'enter account number'
            }));
        } else if (!routingNumber || routingNumber === "") {
            setBankErr((prev) => ({
                ...prev,
                routingNumberErr: 'enter routing number'
            }));
        } else if (routingNumber && routingNumber.length !== 9) {
            setBankErr((prev) => ({
                ...prev,
                routingNumberErr: 'enter routing number with 9 digits'
            }));
        } else {
            sendVerficationOTP();
        }
    };

    const sendVerficationOTP = async ()=>{
        setBtnLoading(true)
        setCurrentOTP('');
        const randomCode = Math.floor(100000 + Math.random() * 900000);
        await axios.post(SEND_VERIFY_OTP,{otp:randomCode})
        .then((response) => {
            setCurrentOTP(randomCode);
            setShowOTPInput(true);
            showToastMessageSuccess(response.data.message);
            setBtnLoading(false)
        })
        .catch((error) => {
            console.log(error);
            showToastMessageError(error?.response?.data?.message);
            setBtnLoading(false)
        });
    }


    const VerifyOTPSubmit = () =>{     
        setBtnLoading(true)
        if(!otp && otp === ""){
            setOTPErr("Please Enter Verfication Code..");
        }
        else{
            if(Number(otp) == currentOTP){
                // console.log("Correct COde");
                setOTPErr("")
                setOTPVerified(true)
                submitForm()
            }
            else{
                setOTPErr("Invalid Code..");
            }
        }
    }


   



    const months = Array.from({ length: 12 }, (_, index) => index + 1); // Generate array [1, 2, ..., 12]

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, index) => currentYear + index); // Generate array [currentYear, currentYear + 1, ..., currentYear + 9]


    return createPortal(
        <Modal
            id=''
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-600px'
            show={show}
            onHide={() => {
                handleClose();
                ClearBankStates();
                 setBankErr([{ accountNameErr:'',accountTypeErr: '', bankNameErr: '', accountNumberErr:'' , routingNumberErr:'',primary_statusErr:'' }]);
            }}
            backdrop={true}
        >
            <ToastContainer />
            <div className='modal-header'>
                    {editable == true ? (
                        <h2>Edit Bank Account</h2>
                    ) : (
                        <h2>Add Bank Account</h2>
                    )}
                    
                
                <div className='btn btn-sm btn-icon btn-secondary close' onClick={() => {
                    handleClose();
                    ClearBankStates();
                     setBankErr([{ accountNameErr:'',accountTypeErr: '', bankNameErr: '', accountNumberErr:'' , routingNumberErr:'',primary_statusErr:'' }]);
                }}>
                    <span aria-hidden="true">&times;</span>
                </div>
            </div>
            <ToastContainer />

            <div className='p-10 pt-0 pb-5'>
            
                <div style={{borderColor: '#EA2467'}}>
                    
                <div >
                    <div className="form-group title_field">
                        <div className="row">
                            <div className="col-12 mb-3">
                                <label className="form-label required">Account Holder Name</label>
                                <input
                                    value={accountName}
                                    onChange={(e) => handleChangeAccountName(e)}
                                    type="text"
                                    name="account_name"
                                    className="form-control w-sm-60"
                                    placeholder='Account Holder Name'
                                />
                                {bankErr && <p className='text-danger position-absolute' style={{ marginTop: "-3px" }}>{bankErr.accountNameErr}</p>}
                            </div>

                            <div className="col-12 mb-3">
                                <label className="form-label required">Account Type</label>
                                <select
                                    value={accountType}
                                    onChange={(e) => handleChangeAccountType(e)}
                                    className="form-select"
                                    placeholder='Type'
                                >
                                    <option value="1" selected>Personal Checking</option>
                                    <option value="2">Personal Saving</option>
                                </select>
                                {bankErr && <p className='text-danger position-absolute' style={{ marginTop: "-3px" }}>{bankErr.accountTypeErr}</p>}
                            </div>

                            <div className="col-12 mb-3">
                                <label className="form-label required">Bank Name</label>
                                <input
                                    value={bankName}
                                    onChange={(e) => handleChangeBankName(e)}
                                    type="text"
                                    name="account_type"
                                    className="form-control"
                                    placeholder='Account Number'
                                />
                                {bankErr && <p className='text-danger position-absolute' style={{ marginTop: "-3px" }}>{bankErr.bankNameErr}</p>}
                            </div>

                            <div className="col-12 mb-3">
                                <label className="form-label required">Account Number</label>
                                <input
                                    value={accountNumber}
                                    onChange={(e) => handleChangeAccountNumber(e)}
                                    type="text"
                                    name="account_type"
                                    className="form-control"
                                    placeholder='Account Number'
                                />
                                {bankErr && <p className='text-danger position-absolute' style={{ marginTop: "-3px" }}>{bankErr.accountNumberErr}</p>}
                            </div>
                            <div className="col-12 mb-3">
                                <label className="form-label required">Routing Number</label>
                                <input
                                    value={routingNumber}
                                    onChange={(e) => handleChangeRoutingNumber(e)}
                                    type="text"
                                    name="account_type"
                                    className="form-control"
                                    placeholder='Routing Number'
                                />
                                {bankErr && <p className='text-danger position-absolute' style={{ marginTop: "-3px" }}>{bankErr.routingNumberErr}</p>}
                            </div>
                            {editable == true && (
                                <div className="col-12 mb-3">
                                <label className="form-label me-5">Primary Bank</label>
                                <input
                                    value={primaryStatus}
                                    onChange={(e) => handleChangePrimaryStatus(e)}
                                    type="checkbox"
                                    name="primary_status"
                                    className="form-check-input"
                                    checked={primaryStatus == 1}
                                />
                                {bankErr && <p className='text-danger position-absolute' style={{ marginTop: "-3px" }}>{bankErr.primary_statusErr}</p>}
                                </div>
                            )}
                            
                            {showOTPInput && (
                                <>
                                <div className="col-12 mb-3">
                                <label className="form-label required">OTP Verification</label>
                                    <input
                                    value={otp}
                                    onChange={(e) => setOTP(e.target.value)}
                                    type="text"
                                    name="otp"
                                    className="form-control"
                                    placeholder='6 Digit Code'
                                />
                                {otpErr && <p className='text-danger position-absolute' style={{ marginTop: "3px" }}>{otpErr}</p>}
                                {/* <button class="btn btn-secondary" type="button" onClick={VerifyOTPSubmit}>Verify</button> */}
                            </div>    
                                </>
                            )}

                        </div>

                        
                    </div>
                    <br />
                </div>
                           
                </div>

                <div className='d-flex justify-content-end'>


                    
                    <div className=''>
                        <button class="btn btn-secondary me-3" onClick={() => {
                            handleClose();
                            ClearBankStates();
                             setBankErr([{ accountNameErr:'',accountTypeErr: '', bankNameErr: '', accountNumberErr:'' , routingNumberErr:'',primary_statusErr:'' }]);
                        }}>Close</button>
                        {currentOTP != '' ? (
                            <button className='btn btn-primary' onClick={VerifyOTPSubmit}>{btnLoading ? 'Processing..' : 'Submit'}</button>
                        ) : (
                             <button className='btn btn-success' onClick={saveUserBank}>{btnLoading ? 'Sending Code..' : 'Save'}</button>
                        )}
                        
                    </div>
                </div>
            </div>

        </Modal>,
        modalsRoot
    );
}

export { AddBank };
